import React from 'react'

// image
// import icon_visa from "../../Assets/svg/payment_visa.svg";
// import icon_mastercard from "../../Assets/svg/payment_mastercard.svg";
// import icon_jcb from "../../Assets/svg/payment_jcb.svg";
// import icon_american_express from "../../Assets/svg/payment_american_express.svg";
import icon_qris from "../../Assets/svg/payment_qris.svg";
import icon_permata from "../../Assets/svg/payment_permata.svg";
import icon_ovo from "../../Assets/svg/payment_ovo.svg";
import icon_link_aja from "../../Assets/svg/payment_link_aja.svg";
import icon_gopay from "../../Assets/svg/payment_gopay.svg";
import icon_dana from "../../Assets/svg/payment_dana.svg";
import icon_bri from "../../Assets/svg/payment_bri.svg";
import icon_bni from "../../Assets/svg/payment_bni.svg";
import icon_bca from "../../Assets/svg/payment_bca.svg";
import icon_mandiri from "../../Assets/svg/payment_mandiri.svg";

function MidtransContainer() {
  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px", fontSize: "1.8rem" }}>
        {/* <div>
            <label>Card Payment</label>
            <div style={{ display: "flex", gap: "10px" }}>
              <img src={icon_visa} alt="visa" style={{ height: "20px" }} />
              <img src={icon_mastercard} alt="mastercard" style={{ height: "20px" }} />
              <img src={icon_jcb} alt="jcb" style={{ height: "20px" }} />
              <img src={icon_american_express} alt="american express" style={{ height: "20px" }} />
            </div>
          </div> */}

        <div style={{ display: "flex", flexDirection: "column", gap: "5px", textDecoration:"underline", fontStyle:"italic" }}>
          <label>QRIS</label>
          <div style={{ display: "flex", gap: "10px" }}>
            <img src={icon_qris} alt="qris" style={{ height: "25px" }} title='QRIS' />
            <img src={icon_gopay} alt="gopay" style={{ height: "25px" }} title='Gopay' />
            <img src={icon_ovo} alt="ovo" style={{ height: "25px" }} title='OVO' />
            <img src={icon_dana} alt="dana" style={{ height: "25px" }} title='Dana' />
            <img src={icon_link_aja} alt="link aja" style={{ height: "25px" }} title='Link Aja' />
          </div>
        </div>


        <div style={{ display: "flex", flexDirection: "column", gap: "5px", textDecoration:"underline", fontStyle:"italic" }}>
          <label>Virtual Account</label>
          <div style={{ display: "flex", gap: "10px" }}>
            <img src={icon_bca} alt="bca" style={{ height: "25px" }} title='BCA' />
            <img src={icon_bri} alt="bri" style={{ height: "25px" }} title='BRI' />
            <img src={icon_bni} alt="bni" style={{ height: "25px" }} title='BNI' />
            <img src={icon_mandiri} alt="mandiri" style={{ height: "25px" }} title='Bank Mandiri' />
            <img src={icon_permata} alt="permata" style={{ height: "25px" }} title='Bank Permata' />
          </div>
        </div>

        <button></button>
      </div>
    </div>
  )
}

export default MidtransContainer